import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[rtColumnResize]',
  standalone: true,
})
export class DataTableColumnResizeDirective {
  @Input('rtColumnResize') public columnId: string;

  constructor(private renderer: Renderer2, private elRef: ElementRef) {}

  public get offsetLeft(): number {
    return this.elRef.nativeElement.offsetLeft;
  }

  public get width(): number {
    return this.elRef.nativeElement.getBoundingClientRect().width;
  }

  public get offsetRight(): number {
    return this.offsetLeft + this.width;
  }

  public setWidth(width: string, minWidth: string | null, maxWidth: string | null): void {
    this.renderer.setStyle(this.elRef.nativeElement, 'width', width);
    this.renderer.setStyle(this.elRef.nativeElement, 'minWidth', minWidth);
    this.renderer.setStyle(this.elRef.nativeElement, 'maxWidth', maxWidth);
  }
}
